import { Client } from '@standardsdigital/ui-components/Logo';

const getCurrentClientCode = (
  element: Element,
  defaultClient: Client = Client.SD,
) => {
  const domClientCode = element.getAttribute('data-client-code');

  if (domClientCode === Client.SO) {
    return Client.SN;
  }

  if (domClientCode && Object.values(Client).includes(domClientCode as Client)) {
    return domClientCode as Client;
  }

  return defaultClient;
};

export default getCurrentClientCode;
